export const useNumberFormat = (value: number) => {
  const formatter = (bool: boolean): any => {
    if (!bool) {
      const convertString: string = value.toString();
      const orginalValue: string = convertString.replace(/,/g, '');
      return Number(orginalValue);
    } else {
      const addComma = (num: string): string =>
        num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const removeString = (num: number): string =>
        num.toString().replace(/[^0-9]/g, '');
      const formattedValue = addComma(removeString(value));
      return formattedValue;
    }
  };

  const formatClientAmount: number = formatter(true);
  const originalClientAmount: number = formatter(false);

  return [formatClientAmount, originalClientAmount];
};
